import React, { useState } from "react";

export default function TestSection() {
  const [result, setResult] = useState(null);

  return (
    <section>
      <h4>Test PDF</h4>

      <input
        type="file"
        accept="application/pdf"
        onChange={() =>
          setResult({ invoice_no: "INV-1023", total: 120000 })
        }
      />

      {result && (
        <pre style={styles.output}>
          {JSON.stringify(result, null, 2)}
        </pre>
      )}
    </section>
  );
}

const styles = {
  output: {
    background: "#111",
    color: "#0f0",
    fontSize: "12px",
    padding: "8px"
  }
};
